export const parseAttachFiles = (value?: string): string[] => {
  try {
    return JSON.parse(value ?? '[]')
  } catch (error) {
    // console.log(error);
    return []
  }
}
